// Синхронизация избранного с аккаунтом:
// - login: объединяем локальное (IndexedDB) с серверным (GET /api/user/wishlist)
// - logout: очищаем локальное избранное
// Локальное поведение (добавление/удаление без авторизации) не меняется.
export default async ({ store }) => {
    if (!process.client) {
        return;
    }

    let wasLoggedIn = store.state.auth && store.state.auth.loggedIn;

    const handleLogin = async () => {
        try {
            await store.dispatch("wishlist/syncOnLogin");
        } catch (e) {
            console.warn("[wishlist] sync error:", e);
        }
    };

    const handleLogout = async () => {
        try {
            await store.dispatch("wishlist/clearLocal");
        } catch (e) {
            console.warn("[wishlist] clear error:", e);
        }
    };

    store.watch(
        (state) => state.auth && state.auth.loggedIn,
        async (loggedIn) => {
            if (loggedIn === wasLoggedIn) {
                return;
            }
            wasLoggedIn = loggedIn;
            if (loggedIn) {
                await handleLogin();
            } else {
                await handleLogout();
            }
        },
        { immediate: false }
    );

    // страница открыта уже авторизованным — синхронизируем сразу,
    // чтобы стор как можно быстрее подтянул серверный список
    if (wasLoggedIn) {
        handleLogin();
    }
};